"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useId } from 'react';
import clsx from 'clsx';
import styles from './Accordion.module.scss.mjs';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { dynamic } from '../../lib/propsContext/dynamicProps/dynamic.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { Button } from '../Button/Button.mjs';
import '@tabler/icons-react';
import '../Icon/Icon.mjs';
import { IconChevronDown } from '../Icon/components/icons/IconChevronDown.mjs';
import { TunnelProvider, TunnelExit } from '@mittwald/react-tunnel';
import { Activity } from '../Activity/Activity.mjs';

const Accordion = (props) => {
  const {
    children,
    className,
    defaultExpanded = false,
    variant = "default",
    ...rest
  } = props;
  const [expanded, setExpanded] = useState(defaultExpanded);
  const rootClassName = clsx(
    styles.accordion,
    expanded && styles.expanded,
    className,
    variant === "outline" && styles.outline
  );
  const headerId = useId();
  const contentId = useId();
  const headerButton = (children2) => /* @__PURE__ */ jsxs(
    Button,
    {
      tunnelId: null,
      unstyled: true,
      "aria-expanded": expanded,
      className: styles.headerButton,
      onPress: () => setExpanded((expanded2) => !expanded2),
      "aria-controls": contentId,
      children: [
        children2,
        /* @__PURE__ */ jsx(IconChevronDown, { className: styles.chevron })
      ]
    }
  );
  const propsContext = {
    Content: {
      className: styles.contentInner,
      tunnelId: "content"
    },
    Heading: {
      className: styles.header,
      level: 4,
      children: dynamic((props2) => headerButton(props2.children))
    },
    Label: {
      className: styles.header,
      children: dynamic((props2) => headerButton(props2.children))
    }
  };
  return /* @__PURE__ */ jsx("div", { ...rest, className: rootClassName, children: /* @__PURE__ */ jsx(
    PropsContextProvider,
    {
      mergeInParentContext: true,
      props: propsContext,
      dependencies: [expanded],
      children: /* @__PURE__ */ jsxs(TunnelProvider, { children: [
        children,
        /* @__PURE__ */ jsx(
          "div",
          {
            "aria-labelledby": headerId,
            id: contentId,
            role: "region",
            hidden: !expanded,
            className: styles.content,
            children: /* @__PURE__ */ jsx(Activity, { isActive: expanded, inactiveDelay: 1e3, children: /* @__PURE__ */ jsx(TunnelExit, { id: "content" }) })
          }
        )
      ] })
    }
  ) });
};

export { Accordion, Accordion as default };
//# sourceMappingURL=Accordion.mjs.map
